module.exports = __webpack_public_path__ + "img/lala_scroll10.0bbfbc78.webp";